<template>

<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M256,0c-49.456,0-89.693,40.237-89.693,89.693v176.279c0,49.45,40.237,89.687,89.693,89.687
			c49.456,0,89.693-39.957,89.693-89.071V89.693C345.693,40.237,305.456,0,256,0z M308.315,266.583
			c0,28.503-23.47,51.698-52.315,51.698s-52.321-23.464-52.321-52.315V89.693c0-28.851,23.47-52.321,52.321-52.321
			s52.321,23.47,52.315,52.321V266.583z"/>
	</g>
</g>
<g>
	<g>
		<rect x="237.314" y="409.226" width="37.372" height="84.088"/>
	</g>
</g>
<g>
	<g>
		<path d="M305.207,474.628h-98.414c-10.321,0-18.686,8.365-18.686,18.686c0,10.321,8.365,18.686,18.686,18.686h98.414
			c10.321,0,18.686-8.365,18.686-18.686C323.893,482.993,315.528,474.628,305.207,474.628z"/>
	</g>
</g>
<g>
	<g>
		<path d="M397.392,234.822c-10.321,0-18.686,8.365-18.686,18.686v14.949c0,67.656-55.049,122.706-122.706,122.706
			c-67.662,0-122.706-55.049-122.706-122.706v-14.949c0-10.321-8.365-18.686-18.686-18.686s-18.686,8.365-18.686,18.686v14.949
			c0,88.267,71.811,160.078,160.078,160.078s160.078-71.811,160.078-160.078v-14.949
			C416.078,243.188,407.713,234.822,397.392,234.822z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
